import { Form, Text } from 'react-form'
import React, { Component } from 'react'
import { Swap, SwapItem } from '@components/Swap'
import { clear, resetPassword } from '@actions/resetPassword'
import { closeLoader, openLoader } from '@actions/loader'

import { InputCheckbox, InputPassword, regexEmail } from '@shared/CustomField'
import { closeModal } from '@actions/modal'
import { connect } from 'react-redux'
import { requestLogin, loginWithGoogleToken } from '@actions/user'
import { checkUserEmail, firstAccessPassword } from '@services/sm-api'
import { withRouter } from '../../utils/withRouter'
import { openGooglePopup } from '../../utils/googlePopup'

const DEFAULT_VALUES = { persitSession: 1 }

class LoginModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: props.active === 'forgot' ? 'forgot' : 'login',
      step: 'email',
      blocked: props.blocked,
      embedded: props.embedded,
      disableSubmit: false,
      successResetPassword: false,
    }
    this._handleSubmit = this._handleSubmit.bind(this)
    this._handleValidation = this._handleValidation.bind(this)
    this._handleRemindPassword = this._handleRemindPassword.bind(this)
    this._handleBackButton = this._handleBackButton.bind(this)
    this._goToPasswordStep = this._goToPasswordStep.bind(this)
    this._goToEmailStep = this._goToEmailStep.bind(this)
    this._checkEmailAndAdvance = this._checkEmailAndAdvance.bind(this)
  }

  // Limpa erros/touched do formulario para que a validacao da etapa seguinte
  // possa ser exibida do zero.
  _resetFormValidation() {
    this.refs.Form.setAllTouched(false, { touched: {}, errors: {} })
  }

  _setFormError(field, message) {
    this.refs.Form.state.errors = { [field]: message }
    this.refs.Form.setAllTouched()
  }

  _focusField(id) {
    const field = document.getElementById(id)
    field && field.focus()
  }

  // Consulta o backend antes de pedir a senha: so avanca se o e-mail existir.
  // Se a consulta falhar (rede/API fora), avanca mesmo assim e deixa o login decidir.
  _checkEmailAndAdvance(email) {
    this.props.openLoader()
    this.setState({ disableSubmit: true })

    return checkUserEmail(email)
      .then(data => {
        if (data && data.exists === false) {
          this._finishEmailCheck()
          this._setFormError('email', 'E-mail não cadastrado. Verifique o e-mail digitado.')
          this._focusField('login-email')
          return
        }

        // Conta sem senha local (criada pelo login com Google, por exemplo): nao adianta
        // pedir senha, entao dispara o e-mail de cadastro de senha.
        if (data && data.set_password === false) {
          return this._sendFirstAccessMail(email)
        }

        this._finishEmailCheck()
        this._goToPasswordStep()
      })
      .catch(() => {
        this._finishEmailCheck()
        this._goToPasswordStep()
      })
  }

  _finishEmailCheck() {
    this.setState({ disableSubmit: false })
    this.props.closeLoader()
  }

  _sendFirstAccessMail(email) {
    return firstAccessPassword({ email })
      .then(() => {
        this._finishEmailCheck()
        this.setState({ active: 'first-access' })
      })
      .catch(() => {
        this._finishEmailCheck()
        this._setFormError('email', 'Não foi possível enviar o e-mail de cadastro de senha. Tente novamente.')
      })
  }

  _goToPasswordStep() {
    this._resetFormValidation()
    this.setState({ step: 'password' }, () => this._focusField('login-password'))
  }

  _goToEmailStep() {
    this.refs.Form.setValue('password', '', true)
    this._resetFormValidation()
    this.setState({ step: 'email' }, () => this._focusField('login-email'))
  }

  _handleSubmit(values) {
    if (this.state.step === 'email') {
      this._checkEmailAndAdvance(values.email)
      return
    }

    this.props.requestLogin(values).then(response => {
      this.props.navigate('/admin')
      if (response.message) {
        this.refs.Form.state.errors = {
          email: response.message.type === 'email' ? response.message.error : '',
          password: response.message.type === 'password' ? response.message.error : '',
        }
        this.refs.Form.setAllTouched()

        if (response.message.type === 'email') {
          this.setState({ step: 'email' })
        }

        if (response.message.type === 'blocked') {
          this.setState({
            blocked: true,
            step: 'email',
          })
        }
      } else {
        this.props.closeModal()
      }
    })
  }

  _handleRemindPassword(values) {
    this.props.openLoader()
    this.setState({ disableSubmit: true })
    this.props
      .resetPassword(values)
      .then(() => {
        console.log('Password reset successful')
        this.setState({ disableSubmit: false })
        this.setState({ successResetPassword: true })
        this.props.closeLoader()
      })
      .catch(error => {
        console.error('Password reset failed:', error)
        this.refs.Form.state.errors = {
          email: 'Não foi possível encontrar sua conta.',
        }
        this.setState({ disableSubmit: false })
        this.refs.Form.setAllTouched()
        this.props.closeLoader()
      })
  }

  _handleValidation({ email = '', password = '' }) {
    return {
      email: this._validateEmail(email),
      password:
        this.state.step === 'password' && password.length === 0 ? 'Por favor, digitar a senha.' : undefined,
    }
  }

  _validateEmail(email) {
    if (email.length === 0) {
      return 'Por favor, digitar o email do usuário'
    }
    return regexEmail.test(email) ? undefined : 'Por favor, digitar um e-mail válido.'
  }

  _handleRemindValidation({ email = '' }) {
    return {
      email: email.length === 0 ? 'Por favor, digitar o email do usuário' : undefined,
    }
  }

  _handleBackButton() {
    this.props.clear()
    this.setState({ active: 'login', step: 'email' })
    this.state.embedded && this.props.closeModal()
  }

  _renderMailSentAlert(text) {
    return (
      <div className="field login-modal__field">
        <div
          className="login-modal__success-alert"
          style={{ textAlign: 'center', padding: '24px', borderRadius: '12px', marginBottom: '20px' }}
        >
          <div
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#ec6262',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h4 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600', color: 'white' }}>
            E-mail enviado com sucesso!
          </h4>
          <p style={{ margin: '0', fontSize: '14px', color: 'white', lineHeight: '1.5' }}>
            {text}
            <br />
            Verifique sua caixa de entrada e também a pasta de spam.
          </p>
        </div>
      </div>
    )
  }

  render() {
    const { closeModal, reset } = this.props

    return (
      <div className={`login-modal ${this.state.blocked && this.state.active === 'login' ? 'blocked' : ''}`}>
        <Swap active={this.state.active}>
          <SwapItem name="login">
            <span className="login-modal__close" onClick={closeModal}>
              X
            </span>
            {this.state.blocked ? (
              <h3 className="login-modal__title">Acesso bloqueado</h3>
            ) : (
              <h3 className="login-modal__title">Entrar</h3>
            )}
            <Form
              ref="Form"
              onSubmit={this._handleSubmit}
              validate={this._handleValidation}
              defaultValues={DEFAULT_VALUES}
            >
              {({ values, submitForm, getError, setAllTouched, ...rest }) => {
                return (
                  <form onSubmit={submitForm} className="login-modal__form">
                    {this.state.blocked && (
                      <div className={`field login-modal__field ${this.state.blocked && 'blocked'}`}>
                        O acesso foi bloqueado por excesso de tentativas. Utilize o link{' '}
                        <strong>Esqueci minha senha</strong> abaixo para prosseguir.
                      </div>
                    )}
                    {!this.state.blocked && this.state.step === 'email' && (
                      <div className="field login-modal__field">
                        <Text
                          id="login-email"
                          className="field__text"
                          field="email"
                          placeholder="digite seu e-mail"
                          autoComplete="off"
                        />
                      </div>
                    )}
                    {!this.state.blocked && this.state.step === 'password' && (
                      <>
                        <div className="login-modal__identity field login-modal__field">
                          <span className="login-modal__identity__email" title={values.email}>
                            {values.email}
                          </span>
                          <button
                            type="button"
                            className="login-modal__identity__change"
                            onClick={this._goToEmailStep}
                          >
                            Alterar
                          </button>
                        </div>
                        <div className="field login-modal__field">
                          <InputPassword id="login-password" placeholder="digite sua senha" field="password" />
                        </div>
                      </>
                    )}
                    <div className="field login-modal__field--checkbox">
                      {!this.state.blocked && this.state.step === 'password' && (
                        <InputCheckbox
                          className="select-book__list__checkbox login-modal__checkbox"
                          field="persitSession"
                        />
                      )}
                      {!this.state.blocked && this.state.step === 'password' && (
                        <label htmlFor="persitSession" className="login-modal__persist">
                          Permanecer conectado
                        </label>
                      )}
                      <span
                        className={`login-modal__forgot ${this.state.blocked && 'blocked'}`}
                        onClick={() => this.setState({ active: 'forgot' })}
                      >
                        Esqueci minha senha
                      </span>
                    </div>
                    {!this.state.blocked && (
                      <div className="field login-modal__field--button">
                        <button
                          className="button__normal login-modal__button"
                          type="submit"
                          disabled={this.state.disableSubmit}
                        >
                          {this.state.step === 'email' ? 'Avançar' : 'Entrar'}
                        </button>
                      </div>
                    )}

                    {this.state.step === 'email' && (
                      <div className='login-modal__social-section'>
                        <div className="login-modal__divider">
                          <span>ou</span>
                        </div>
                        <div className="login-modal__social">
                          <button
                            type="button"
                            className="login-modal__google-button"
                            onClick={() => {
                              openGooglePopup(
                                (token, user) => {
                                  console.log('LoginModal: token recebido, iniciando login')
                                  this.props.loginWithGoogleToken(token, user).then(() => {
                                    console.log('LoginModal: login concluído, fechando modal e navegando')
                                    this.props.closeModal()
                                    this.props.navigate('/admin')
                                  })
                                },
                                (err) => console.error('Erro Google login:', err)
                              )
                            }}
                          >
                            <svg width="25" height="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
                              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                            </svg>
                            Entrar com Google
                          </button>
                        </div>
                      </div>
                    )}
                  </form>
                )
              }}
            </Form>
          </SwapItem>
          <SwapItem name="forgot">
            {/*
              reset.code !== '200' ?
                <span className="login-modal__back" onClick={() => this.setState({ active: 'login' })}> voltar </span>
              : null
            */}
            <span className="login-modal__close" onClick={closeModal}>
              X
            </span>
            <h3 className="login-modal__title">Esqueci minha senha</h3>
            <Form ref="Form" onSubmit={this._handleRemindPassword} validate={this._handleRemindValidation}>
              {({ values, submitForm, getError, setAllTouched }) => {
                return (
                  <form onSubmit={submitForm} className="login-modal__form">
                  {!this.state.successResetPassword ? (
                  <>
                  <div className="field login-modal__field">
                    <Text className="field__text" field="email" placeholder="digite seu e-mail" autoComplete="off" />
                  </div>
                  <div className="field login-modal__field--button">
                    <button
                    type="button"
                    className="button__normal login-modal__button--grey"
                    onClick={this._handleBackButton}
                    >
                    Voltar
                    </button>
                    <button
                    className="button__normal login-modal__button"
                    type="submit"
                    disabled={this.state.disableSubmit}
                    >
                    Alterar senha
                    </button>
                  </div>
                  </>
                  ) : (
                  this._renderMailSentAlert(
                    'Enviamos um link para seu e-mail para que você possa redefinir sua senha.',
                  )
                  )}
                  </form>
                )
              }}
            </Form>
          </SwapItem>
          <SwapItem name="first-access">
            <span className="login-modal__close" onClick={closeModal}>
              X
            </span>
            <h3 className="login-modal__title">Cadastre sua senha</h3>
            {this._renderMailSentAlert(
              'Seu usuário ainda não possui uma senha cadastrada. Enviamos um link para seu e-mail para que você possa criar sua senha.',
            )}
            <div className="field login-modal__field--button">
              <button
                type="button"
                className="button__normal login-modal__button--grey"
                onClick={() => this.setState({ active: 'login', step: 'email' })}
              >
                Voltar
              </button>
            </div>
          </SwapItem>
        </Swap>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.sessionReducer,
  reset: state.resetPassword,
})

const mapDispatchToProps = {
  requestLogin,
  loginWithGoogleToken,
  closeModal,
  resetPassword,
  clear,
  openLoader,
  closeLoader,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginModal))

